import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { ITableColumn } from 'src/app/core/models/table.model';
import { PageListComponent } from 'src/app/layout/pages/page-list/page-list.component';
import { IPrelievo, PRELIEVO_STATUS, getStatusIcon } from '../models/prelievo.model';
import { QueryService } from 'src/app/core/services/query.service';
import { CONTROLLI_COLUMNS, PRELIEVO_QUERY_SERVICE_INSTANCE } from '../prelievo.config';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { InputDateComponent } from 'src/app/shared/components/inputs/input-date/input-date.component';
import { MatBadgeModule } from '@angular/material/badge';
import { FiltersGroupComponent } from 'src/app/shared/components/filters/filters-group/filters-group.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { IInputToggleGroupOption, InputToggleGroupComponent } from 'src/app/shared/components/inputs/input-toggle-group/input-toggle-group.component';
import { FiltersPanelComponent } from 'src/app/shared/components/filters/filters-panel/filters-panel.component';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';


@Component({
  selector: 'app-lista-page',
  standalone: true,
  imports: [
    CommonModule,
    MatBadgeModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatDividerModule,
    MatTooltipModule,
    MatIconModule,
    PageListComponent,
    InputDateComponent,
    InputToggleGroupComponent,
    FiltersPanelComponent,
    FiltersGroupComponent,
  ],
  templateUrl: './lista-page.component.html',
  styleUrl: './lista-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ListaPageComponent {
  filterForm: FormGroup;
  data = this.queryService.store.selectKey('list');
  columns: ITableColumn[] = CONTROLLI_COLUMNS;
  customClickFunction:Function=(row:any)=>{
    console.log(row.uuid, row.dataOraPrelievo)
    if(row.uuid && row.dataOraPrelievo){
      this.navigateToDetail(row.uuid.toString(), row.dataOraPrelievo.toString())
    }

  }


  statusOptions: Array<IInputToggleGroupOption> = []

  constructor(
    private readonly fb: FormBuilder,
    @Inject(PRELIEVO_QUERY_SERVICE_INSTANCE) public readonly queryService: QueryService<IPrelievo>,
    private router: Router
  ) {
    this.filterForm = this.fb.group({
      search: this.fb.control('', []),
      filters: this.fb.group({
        dataPrelievo_greaterThanOrEqual: this.fb.control<Date | null>(null, []),
        dataPrelievo_lessThanOrEqual: this.fb.control<Date | null>(null, []),
        dataAnalisi_greaterThanOrEqual: this.fb.control<Date | null>(null, []),
        dataAnalisi_lessThanOrEqual: this.fb.control<Date | null>(null, []),
        status_in: this.fb.control<Array<string> | null>(null, [])
      })
    });

    PRELIEVO_STATUS.forEach((status) => {
      this.statusOptions.push({
        label: getStatusIcon(status) + ' ' + status,
        value: status
      });
    })
  }
  ngOnInit(){
    this.filters.get('dataPrelievo_greaterThanOrEqual')?.valueChanges.subscribe(value => {
      if (value) {
        const date = DateTime.fromISO(value.toString());
        if (date.isValid) {
          // Trasforma la data in formato YYYYMMDD
          const formattedDate = date.toFormat('yyyy-LL-dd');
          // Aggiorna il valore del FormControl con la data formattata
          this.filters.get('dataPrelievo_greaterThanOrEqual')?.setValue(formattedDate, { emitEvent: false });
        }
      }
    });
    this.filters.get('dataPrelievo_lessThanOrEqual')?.valueChanges.subscribe(value => {
      if (value) {
        const date = DateTime.fromISO(value.toString());
        if (date.isValid) {
          // Trasforma la data in formato YYYYMMDD
          const formattedDate = date.toFormat('yyyy-LL-dd');
          // Aggiorna il valore del FormControl con la data formattata
          this.filters.get('dataPrelievo_lessThanOrEqual')?.setValue(formattedDate, { emitEvent: false });
        }
      }
    });
  }
  get filters(): FormGroup {
    return this.filterForm.get('filters') as FormGroup;
  }

  get prelievoFiltersCount() {
    let count = 0;
    const fields = ['dataPrelievo_greaterThanOrEqual', 'dataPrelievo_lessThanOrEqual'];
    fields.forEach((field) => {
      if (this.filters.value[field] !== null) {
        count++;
      }
    })
    return count;
  }
  private navigateToDetail(uuid: string, dataOraPrelievo:string) {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/');
    const indexFind = urlSegments.findIndex((element) => element == 'controlli')
    urlSegments.splice(indexFind+1, urlSegments.length)
    urlSegments.push('lista');
    urlSegments.push(uuid.toString());
    urlSegments.push(dataOraPrelievo.toString());
    const newUrl = urlSegments.join('/');
    this.router.navigate([newUrl]);
  }

}
